import { getAmountInDollarsAndCents } from "Utilities/Amount/getAmountInDollarsClean";
import { formatAmountInCentsForDisplay } from "Utilities/Number/formatAmountInCentsForDisplay";

export function getAmountToDisplay(state) {
  if (!state) return "";

  const amountToUse = state.pollingPaymentResponse?.amount
    ? // default scenario... where user submitted a payment, and it was successful
      state.pollingPaymentResponse?.amount
    : state.modifyPayment?.paymentAlreadyCompleted
    ? // if came in via cancel/modify, but too late and scheduled payment already processed
      getAmountInDollarsAndCents(state.modifyPayment.originalAmount)
    : state.amount
    ? // for success screen (if payment didn't complete processing w/i timeout)
      // OR if modified a scheduled payment
      state.amount
    : "";

  // add-on gifts: when a user adds an add-on gift, the amount is added to the total
  const { addOnAmounts } = state;
  const addOns = addOnAmounts.filter((a) => a.isChecked);
  if (addOns?.length) {
    let addOnTotal = 0;
    for (let addOnAmount of addOns) {
      addOnTotal +=
        Math.round((parseFloat(addOnAmount.amount) + Number.EPSILON) * 100) /
        100;
      //addOnTotal += parseFloat(addOnAmount.amount);
    }
    return formatAmountInCentsForDisplay(
      (parseFloat(amountToUse) + addOnTotal) * 100
    );
  }

  // default scenario... where user submitted a payment, and it was successful
  if (state.pollingPaymentResponse?.amount) {
    return formatAmountInCentsForDisplay(state.pollingPaymentResponse.amount);
  }

  // if came in via cancel/modify, but too late and scheduled payment already processed
  if (state.modifyPayment?.paymentAlreadyCompleted) {
    return formatAmountInCentsForDisplay(state.modifyPayment.originalAmount);
  }

  if (state.amount) {
    // for success screen (if payment didn't complete processing w/i timeout)
    // OR if modified a scheduled payment
    return formatAmountInCentsForDisplay(Number(state.amount) * 100);
  }

  return "";
}
